import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { getChangeRight, getClubVip, getEcardDetail, getUserInfo } from '../../reducers/selectors'
import { CertDetailList } from '../../components/CertDetailList/CertDetailList'
import { WhiteSpace } from 'antd-mobile'
import { isCert } from '../../utils/cert'
import { isMainlandUser } from '../../utils/user'
import { Button, Space } from 'antd-mobile-v5'
import { isWechat } from '../../utils/wechat'
import { useDownloadWallCert, useErrorModal, useGetFreeCred } from '../../services/hooks'
import { useShowMessage } from '../../services/hooks/ui'
import { FormattedMessage, useIntl } from 'react-intl'
import BottomNav from '../../components/HomeNav/BottomNav'
import CertShowWrapped from '../../components/CertDetail/CertShowWrapped'
import { useLocation } from 'react-router-dom'
import MainlandCertShowWrapper from '../../components/CertDetail/MainlandCertShowWrapper'
import CertDetailPanel from '../../components/CertDetail/CertDetailPanel'
import { UClick } from '../../components/common/utils'
import OceanConventionDailyPopup from '../../components/CertDetail/OceanConventionDailyPopup'

const CertDetailPage = ({ ecard, userInfo, isClubVip, hasChangeRight }) => {
  const showMessage = useShowMessage()
  const location = useLocation()
  const [currentCardDetail, setCurrentCardDetail] = useState(null)

  const { loading, run: getFreeCard } = useGetFreeCred({
    onSuccess: () => showMessage('apply-for-free-card-ok', '/certs'),
  })
  useEffect(() => {
    document.getElementById('root').scrollTop = 0
  }, [location])

  useEffect(() => {
    UClick('certDetailPage')
  }, [])

  if (!ecard) return null
  return (
    <>
      {/* 保护海洋每日弹窗 */}
      <OceanConventionDailyPopup />
      {isMainlandUser(userInfo) ? (
        <>
          <MainlandCertShowWrapper
            cert={ecard}
            hasChangeRight={hasChangeRight}
            setCurrentCardDetail={setCurrentCardDetail}
            currentCardDetail={currentCardDetail}
          />
          <CertDetailPanel
            isClubVip={isClubVip}
            currentCardDetail={currentCardDetail}
            cert={ecard}
            hasChangeRight={hasChangeRight}
          />
        </>
      ) : (
        <>
          <WhiteSpace />
          <Space block direction="vertical" style={{ padding: '8px 16px' }}>
            <CertShowWrapped cert={ecard} />
            <DownloadPaperCert
              affiliateCredentialId={ecard.affiliateCredentialId}
              affiliateCertificationId={ecard.affiliateCertificationId}
              certificationName={ecard.certificationName}
            />
          </Space>
          {ecard.getFreeCard ? (
            <Space block direction="vertical" style={{ padding: '0 16px' }}>
              <Button block color="primary" loading={loading} onClick={() => getFreeCard(ecard.uniqueId)}>
                <FormattedMessage id="apply-for-free-card" />
              </Button>
            </Space>
          ) : (
            <p style={{ padding: '4px 16px 0', fontSize: '.8rem' }}>
              <FormattedMessage
                id="cardRequest-non-mainland"
                values={{
                  url: isCert(ecard) ? (
                    <a href="https://www.padi.com/certification-cards">
                      {' '}
                      PADI <FormattedMessage id="cardRequest-non-mainland-diver" />
                    </a>
                  ) : (
                    <a href="https://pro.padi.com">
                      {' '}
                      PADI <FormattedMessage id="cardRequest-non-mainland-pro" />
                    </a>
                  ),
                }}
              ></FormattedMessage>
            </p>
          )}
        </>
      )}
      <CertDetailList cert={ecard} user={userInfo} />
      <div style={{ width: '100%', height: '60px' }}></div>
      <BottomNav isMainlandUser={isMainlandUser(userInfo)} />
    </>
  )
}

function DownloadPaperCert({ affiliateCredentialId, affiliateCertificationId, certificationName }) {
  const { formatMessage } = useIntl()
  const showErrorModal = useErrorModal()
  const { loading, run: download } = useDownloadWallCert()
  if (!affiliateCredentialId && certificationName !== 'Mermaid Performance Diver') return null
  return (
    <Button
      loading={loading}
      color="primary"
      fill="outline"
      block
      onClick={() => {
        if (isWechat()) {
          showErrorModal(formatMessage({ id: 'wechat-wall-cert' }))
        } else {
          let data
          if (affiliateCertificationId) data = { affiliateCertificationId, ecardType: 'CERTIFICATION' }
          else data = { affiliateCredentialId, ecardType: 'CREDENTIAL' }
          download(data)
        }
      }}
    >
      <FormattedMessage id="download-wall-cert" />
    </Button>
  )
}

function mapStateToProps(state, ownProps) {
  return {
    ecard: getEcardDetail(ownProps.match.params.certId)(state),
    userInfo: getUserInfo(state),
    isClubVip: getClubVip(state),
    hasChangeRight: getChangeRight(state),
  }
}

export default connect(mapStateToProps, null)(CertDetailPage)
